import React, { useEffect, useState } from 'react';
import { Box, FormControl, Grid, MenuItem, Select, Typography } from '@mui/material';
import { get_materias } from '../services/api';
import { UseSetLenguajePorPais } from '../hooks/UseSetLenguajePorPais';
import { useTranslation } from 'react-i18next';


export default function GetMaterias({ gradoId, onMateriaChange, objetivos, selectedMateria }) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation(); // Hook de traducción

  //Hook para lenguaje según país
  UseSetLenguajePorPais();


  useEffect(() => {
    async function ObtenerDatosDeAPI() {
      try {
        const { data, status } = await get_materias();
        if (status === 200) {
          const datos = data;
          const materiasArray = Object.entries(datos).map(([nombre, id]) => ({ id: id.toString(), nombre }));
          setData(materiasArray);
        } else {
          console.error('La solicitud a la API no fue exitosa.');
        }
      } catch (error) {
        console.error('Se produjo un error al realizar la solicitud a la API:', error);
      }
    }

    ObtenerDatosDeAPI();
  }, []);

  useEffect(() => {
    if (gradoId && objetivos.length > 0) {
      const materiasId = [...new Set(objetivos.map((obj) => obj.materia))];
      const materiasList = data.filter((d) => materiasId.includes(d.id));
      setFilteredData(materiasList);

    }
  }, [gradoId, data, objetivos]);

  const handleMateriaChange = (event) => {
    const selectedMateria = event.target.value;
    const nameSelectedMateria = filteredData.find((materia) => materia.id === selectedMateria);

    onMateriaChange(nameSelectedMateria);
    console.log(selectedMateria);
  };

  return (
    <Grid item xs={12}>
      <Box>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1rem', fontWeight: 'bold', color: '#336B87' }}>
          {t('asignatura')}
        </Typography>
        <FormControl fullWidth>
          <Select
            labelId="select-subject"
            id="select-subject"
            variant="outlined"
            value={selectedMateria || ''}
            displayEmpty
            onChange={handleMateriaChange}
            sx={{
              fontFamily: 'montserrat',
              fontSize: '14px',
              borderRadius: 2, // Aplicar border-radius
              '& .MuiOutlinedInput-root': {
                borderRadius: 2, // Aplica el border-radius al contenedor
              },
              '& fieldset': {
                borderColor: '#BDBDBD', // Color gris para el borde
              },
              '&:hover fieldset': {
                borderColor: '#9E9E9E', // Color gris más oscuro al hover
              },
              '&.Mui-focused fieldset': {
                borderColor: '#005559', // Color al foco
              },
              '& .MuiSelect-select': {
                color: selectedMateria ? '#005559' : '#B3D1D1', // Placeholder color
              },
            }}

          >
            <option hidden value="">
              Selecciona por ejemplo: Ciencias sociales
            </option>
            {filteredData.map((materia) => (
              <MenuItem key={materia.id} value={materia.id} sx={{ color: '#005559' }}>
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '0.8rem', color: '#336B87' }}>
                  {materia.nombre}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
}
